export default __webpack_public_path__ + "static/media/transferencia_instr.cfcdf9c2.png";